import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/document-services/account-apply/page.tsx");
